import { alignBreakpointCenterMenuItem } from '../menu-item/align-center-breakpoint-menu-item';
import { alignBreakpointLeftMenuItem } from '../menu-item/align-left-breakpoint-menu-item';
import { alignBreakpointRightMenuItem } from '../menu-item/align-right-breakpoint-menu-item';
import { removeBreakpointMenuItem } from '../menu-item/remove-breakpoint-menu-item';

// menu item imports
import { type ContextMenuList } from '../types/context-menu-list.type';

export const breakpointMenuList: Array<ContextMenuList> = [
	removeBreakpointMenuItem(),
	alignBreakpointLeftMenuItem(),
	alignBreakpointRightMenuItem(),
	alignBreakpointCenterMenuItem()
];
